// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1my7t","col":"styles_col__2IO6e"};